export default {
  consent: {
    title: 'Valoramos tu privacidad',
    descriptionStart: 'Utilizamos tecnologías de seguimiento para mejorar tu experiencia y analizar cómo utilizas nuestro servicio. Al hacer clic en "Aceptar", das tu consentimiento para el uso de estas tecnologías. Lee nuestra ',
    privacyLinkText: 'Política de Privacidad',
    descriptionEnd: ' para más detalles.',
    accept: 'Aceptar',
    decline: 'Rechazar',
  }
}